<template>
    <div>
        <div class="Search-title">
            <div>{{ $t('tag.labelProcessing') }}</div>
        </div>
        <template>
            <Tabs size="small" :animated="false">
                <TabPane :label="$t('tag.standardTag')">
                    <div class="Tag-topTime">
                        <standard-tag-search></standard-tag-search>
                    </div>
                    <table-standard-tag></table-standard-tag>
                </TabPane>
                <!-- 隐藏"标签映射" 详情见 sme-966 -->
                <!-- <TabPane :label="$t('tag.tagMapping')">
                    <div class="Tag-topTime">
                        <tag-mapping-search></tag-mapping-search>
                    </div>
                    <table-tag-mapping></table-tag-mapping>
                </TabPane> -->
                <TabPane :label="$t('tag.resourceTag')">
                    <div class="Tag-topTime">
                        <resource-tag-search></resource-tag-search>
                    </div>
                </TabPane>
                <TabPane label="标签纠正">
                    <div class="Tag-topTime">
                        <label-correction></label-correction>
                    </div>
                </TabPane>
            </Tabs>
        </template>
    </div>
</template>
<script>
    import StandardTagSearch from '../tag_management/StandardTagSearch';
    import ResourceTagSearch from '../tag_management/ResourceTagSearch';
    import TagMappingSearch from "../tag_management/TagMappingSearch";
    import TableStandardTag from "../tag_management/TableStandardTag";
    import TableTagMapping from "../tag_management/TableTagMapping";
    import LabelCorrection from "../tag_management/label_correction/LabelCorrection";
    export default {
        name: 'Tag',
        components: {
            StandardTagSearch,
            ResourceTagSearch,
            TagMappingSearch,
            TableStandardTag,
            TableTagMapping,
            LabelCorrection
        }
    }
</script>

<style scoped>
    .Search-title
    {
        width: 100%;
        font-size: 13px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        padding: 15px 0px 8px 4px;
        font-weight: 600;
    }
    .Tag-topTime
    {
        width: 100%;
        margin-bottom: 14px;
    }
</style>



// WEBPACK FOOTER //
// src/components/configuration/label_management/tag_management/Tag.vue